import React from "react";
import MenuBar from "../components/menuBarLoggedIn/menuBarLoggedIn.jsx";
import "../styles/transcoPage.css";
import abc from "../assets/svgs/logos/abc transport.svg"
import chisco from "../assets/svgs/logos/chisco.svg"
import guo from "../assets/svgs/logos/guo.svg"
import gltl from "../assets/svgs/logos/gltl.svg"
import trimage from "../assets/images/Group 87.png"
import downChevron from "../assets/svgs/down-chevron.svg"
import Footer from "../components/footer";


const TranscoPage = () => {
  return (
    <>
      <div>
        <MenuBar/>
        <main className="transco-main">
          <section className="transco-hero">
            <div className="transco-hero-wrapper">
              <h1>Join our <span style={{ color: "#037743"}}>Transco family</span></h1>
              <p>Expand your reach and take your transport business to the next level</p>
              <a href="">Register</a>
            </div>
          </section>
          <section className="partners">
            <div className="partners-wrapper">
              <h2><span style={{color: "#037743"}}>Transcos</span> that love partnering with us</h2>
              <section>
                <img src={abc} alt="ABC Transport" />
                <img src={chisco} alt="Chisco" />
                <img src={guo} alt="Guo" />
                <img src={gltl} alt="Gltl" />
                <img src={abc} alt="ABC Transport" />
                <img src={gltl} alt="Gltl" />
              </section>
            </div>
          </section>
          <section className="why-join">
            <div className="why-join-wrapper">
              <img src={trimage} alt="" />
              <article>
                <h1>Why join our <span style={{color: "#037743"}}>Transco family?</span></h1>
                <p>
                Partner with Shuttle9ja and reach thousands of potential customers across Nigeria, we offer:<br></br>
                  <span>
                    <span style={{color: "#037743", fontWeight: "300", fontSize: "24px"}}>Operations Management</span> <span style={{opacity: "80%", color: "white"}}>: Our easy-to-use platform makes it simple for you to manage your pricing and availability from anywhere in the world.</span><br></br>
                    <span style={{color: "#037743", fontWeight: "300", fontSize: "24px"}}>Secure Payments</span> <span style={{opacity: "80%", color: "white"}}>: Enjoy safe, fast and flexible payment
                    options for your customers with low transaction rates.</span><br></br>
                    <span style={{color: "#037743", fontWeight: "300", fontSize: "22px"}}>Help and Support</span> <span style={{opacity: "80%", color: "white"}}>: We provide value-added services, including customer support that takes your business to the next level.</span>
                  </span>
                </p>
              </article>
            </div>
          </section>
          <section className="faq">
            <div className="faq-wrapper">
              <h1>Frequently Asked Questions</h1>
              <section className="faqs">
                    <div className="faq">
                      <div className="question">
                        <p>How does Shuttle9ja work for transport companies?</p>
                        <img src={downChevron} alt="" />
                      </div>
                      <div className="answer">
                        <p></p>
                      </div>
                    </div>
                    <div className="faq">
                      <div className="question">
                        <p>How do I sign up my transport company with Shuttle9ja?</p>
                        <img src={downChevron} alt="" />
                      </div>
                      <div className="answer">
                        <p></p>
                      </div>
                    </div>
                    <div className="faq">
                      <div className="question">
                        <p>What are the requirements for transport companies to sign up with Shuttle9ja?</p>
                        <img src={downChevron} alt="" />
                      </div>
                      <div className="answer">
                        <p></p>
                      </div>
                    </div>
                    <div className="faq">
                      <div className="question">
                        <p>How long does it take to get my transport company set up on Shuttle9ja?</p>
                        <img src={downChevron} alt="" />
                      </div>
                      <div className="answer">
                        <p></p>
                      </div>
                    </div>
                    <div className="faq">
                      <div className="question">
                        <p>What type of vehicles are allowed on Shuttle9ja’s platform?</p>
                        <img src={downChevron} alt="" />
                      </div>
                      <div className="answer">
                        <p></p>
                      </div>
                    </div>
                    <div className="faq">
                      <div className="question">
                        <p>How can I manage my transport company’s schedules and availability on Shuttle9ja?</p>
                        <img src={downChevron} alt="" />
                      </div>
                      <div className="answer">
                        <p></p>
                      </div>
                    </div>
                    <div className="faq">
                      <div className="question">
                        <p>How does shuttle9ja help transport companies partnering with shuttle9ja?</p>
                        <img src={downChevron} alt="" />
                      </div>
                      <div className="answer">
                        <p></p>
                      </div>
                    </div>
                    <div className="faq">
                      <div className="question">
                        <p>What are the fees and charges for transport companies partnering with Shuttle9ja</p>
                        <img src={downChevron} alt="" />
                      </div>
                      <div className="answer">
                        <p></p>
                      </div>
                    </div>
                    <div className="faq">
                      <div className="question">
                        <p>How can i get in touch with shuttle9ja’s customer support team for support companies?</p>
                        <img src={downChevron} alt="" />
                      </div>
                      <div className="answer">
                        <p></p>
                      </div>
                    </div>
                  </section>
            </div>
          </section>
        </main>
       <Footer />
      </div>
    </>
  );
};
export default TranscoPage;